import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useDeleteVenue } from 'queries/venue.query'

export function DeleteVenueModal({ isOpen, onClose, venue }) {
  const toast = useToast()
  const deleteVenueMutation = useDeleteVenue()

  const handleDelete = async () => {
    if (!venue) return
    try {
      await deleteVenueMutation.mutateAsync(venue.id)
      toast({
        title: 'Venue deleted',
        description: 'Venue removed successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      onClose()
    } catch (err) {
      toast({
        title: 'Failed to delete venue',
        description: err?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Venue</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete <strong>{venue?.name}</strong>?
            This will also affect any seating plans associated with this venue.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={deleteVenueMutation.isPending}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
